import { Typography, useTheme } from '@mui/material';

import { Header } from '@/components/Header/Header';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { selectIsMinorAccount } from '@/redux/user-data';

import { getDataTestId } from '@/utils/browser';

import AccountTypeForm from '../components/AccountTypeForm';

import { Background, Container } from './AccountType.styled';

export function AccountTypePage() {
  const { t } = useTranslate();
  const theme = useTheme();
  const isMinorAccount = useAppSelector(selectIsMinorAccount);

  return (
    <Background>
      <Container>
        <Header />
        <Typography
          variant="h2"
          textAlign="center"
          mb={1}
          {...getDataTestId('account-type-title')}
        >
          {isMinorAccount
            ? t('accountType.joint.title')
            : t('accountType.title')}
        </Typography>
        <Typography
          variant="body2"
          color={theme.palette.neutral[800]}
          textAlign="center"
          mb={4}
          {...getDataTestId('account-type-body')}
        >
          {isMinorAccount ? t('accountType.joint.body') : t('accountType.body')}
        </Typography>
        <AccountTypeForm />
      </Container>
    </Background>
  );
}

export default AccountTypePage;
